import { Typography } from '@mui/material';
import { FunctionComponent } from 'react';

interface IProps {
  text: string;
}

export const TableHeaderTypography: FunctionComponent<IProps> = ({ text }) => (
  <Typography
    fontFamily="Crique Grotesk"
    fontSize="16px"
    color="#3D3D3D"
    fontWeight="500"
    lineHeight="18.4px"
  >
    {text}
  </Typography>
);
